import { render, staticRenderFns } from "./BoardAdminList.vue?vue&type=template&id=ee3b54ce"
import script from "./BoardAdminList.ts?vue&type=script&lang=ts&external"
export * from "./BoardAdminList.ts?vue&type=script&lang=ts&external"
import style0 from "./BoardAdminList.vue?vue&type=style&index=0&id=ee3b54ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports